import axios, { endpoints } from 'src/utils/axios';

import { setSession } from './utils';
import { STORAGE_KEY } from './constant';

/** **************************************
 * Sign in
 *************************************** */
export const signInWithPassword = async ({ UserName, Password }) => {
  try {
    // const res = await axios.post(
    //   `${endpoints.auth.signIn}?UserName=${UserName}&Password=${Password}`,
    //   null,
    //   {
    //     headers: {
    //       Accept: 'text/plain',
    //     },
    //   }
    // );

    // NEW LOGIN
    const res = await axios.post(
      `${endpoints.auth.signIn}/${UserName}/login`,
      {
        password: Password,
      },
      {
        headers: {
          Accept: 'text/plain',
        },
      }
    );

    const accessToken = res.data;

    if (!accessToken) {
      throw new Error('Access token not found in response');
    }

    setSession(accessToken);
  } catch (error) {
    console.error('Error during sign in:', error);
    throw error;
  }
};

/** **************************************
 * Sign up
 *************************************** */
export const signUp = async ({ email, password, firstName, lastName }) => {
  const params = {
    email,
    password,
    firstName,
    lastName,
  };

  try {
    const res = await axios.post(endpoints.auth.signUp, params);

    const { accessToken } = res.data;

    if (!accessToken) {
      throw new Error('Access token not found in response');
    }

    localStorage.setItem(STORAGE_KEY, accessToken);
  } catch (error) {
    console.error('Error during sign up:', error);
    throw error;
  }
};

/** **************************************
 * Sign out
 *************************************** */
export const signOut = async () => {
  try {
    await setSession(null);
  } catch (error) {
    console.error('Error during sign out:', error);
    throw error;
  }
};
